import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

import { TooltipProvider } from '@/components/base'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { Snackbars } from '@/components/Snackbars'
import { useViewportBounds } from '@/hooks/use-viewport-bounds'

export type RouterContext = {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
})

function RootLayout() {
  useViewportBounds()

  return (
    <ErrorBoundary>
      <TooltipProvider>
        <div className="flex h-full flex-col bg-ground">
          <Outlet />
        </div>
        <Snackbars />
      </TooltipProvider>
    </ErrorBoundary>
  )
}
